import * as React from 'react'

import {
  Box,
  Button,
  Variants as ButtonVariants,
  Icon,
  NoticeBox,
  Text,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
export enum UpgradeActions {
  knowMore = 'know_more',
  contactCX = 'contact_cx',
}

interface UpgradeAction {
  type: UpgradeActions
  onClick?: () => void
  to?: string
  disabled?: boolean
}

interface Props {
  title?: string
}

type LargeProps = Props & {
  body?: string
  currentPlanName?: string
  action?: UpgradeAction
  imageSrc?: string
}

type SmallProps = Props & {
  action?: UpgradeAction
}

type TinyProps = Props

interface BannerProps {
  message: string
  button?: React.ReactNode
}

interface UpgradeButtonProps {
  action: UpgradeAction
}

const UpgradeButton = ({ action }: UpgradeButtonProps) => {
  const text =
    action.type === UpgradeActions.knowMore
      ? i18n.t('packaging.upgrade_plan.buttons.know_more')
      : i18n.t('packaging.upgrade_plan.buttons.contact_cx')
  const type: ButtonVariants = action.type === UpgradeActions.contactCX ? 'upgrade' : 'secondary'

  if (action.to) {
    return (
      <Button.Router type={type} to={action.to} onClick={action.onClick} disabled={action.disabled}>
        {text}
      </Button.Router>
    )
  }

  return (
    <Button type={type} onClick={action.onClick} disabled={action.disabled}>
      {text}
    </Button>
  )
}

const Large = ({ title, body, currentPlanName, imageSrc, action }: LargeProps) => {
  return (
    <Box
      className={'Upgrade_upgradeBox'}
      height="fit-content"
      padding="s24"
      gap="s24"
      flexDirection="column"
      justifyContent="flexStart"
      alignItems="flexStart"
      textAlign="left"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      background="grey000White"
    >
      {imageSrc && (
        <Box width="full" height="full" justifyContent="center" alignItems="center">
          <img
            alt={i18n.t('packaging.upgrade_plan.img_alt')}
            className={'Upgrade_img'}
            src={imageSrc}
          />
        </Box>
      )}
      <Box gap="s16">
        <Box gap="s4">
          <Box alignItems="center" flexDirection="row" gap="s4" justifyContent="flexStart">
            <Box flexNoShrink>
              <Icon.Medium color="tangerine1000" icon="lock-locked" />
            </Box>
            <Text.Normal color="grey1000" weight="medium">
              {title ? title : i18n.t('packaging.upgrade_plan.title')}
            </Text.Normal>
          </Box>
          <Text.Normal>
            {body
              ? body
              : i18n.t('packaging.upgrade_plan.body', { plan_name: currentPlanName || 'Business' })}
          </Text.Normal>
        </Box>
        {action && <UpgradeButton action={action} />}
      </Box>
    </Box>
  )
}

const Small = ({ title, action }: SmallProps) => {
  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="fit-content"
      paddingX="s16"
      paddingY="s12"
      gap="s12"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      background="grey100"
    >
      <Box alignItems="center" flexDirection="row" gap="s4" justifyContent="flexStart">
        <Box flexNoShrink>
          <Icon.Medium color="tangerine1000" icon="lock-locked" />
        </Box>
        <Text.Normal color="grey1000" weight="medium">
          {title ? title : i18n.t('packaging.upgrade_plan.title')}
        </Text.Normal>
      </Box>
      {action && <UpgradeButton action={action} />}
    </Box>
  )
}

const Tiny = ({ title }: TinyProps) => {
  return (
    <Box paddingTop="s6" flexDirection="row">
      <Box
        height="fit-content"
        borderRadius={{ all: 'abs006' }}
        background="grey200"
        alignItems="center"
        flexDirection="row"
        paddingY="s2"
        paddingLeft="s6"
        paddingRight="s8"
        gap="s4"
        justifyContent="flexStart"
      >
        <Box flexNoShrink>
          <Icon.Medium color="tangerine1000" icon="lock-locked" />
        </Box>
        <Text.Normal color="grey1000" size="200">
          {title ? title : i18n.t('packaging.upgrade_plan.title')}
        </Text.Normal>
      </Box>
    </Box>
  )
}

const Banner = ({ message, button }: BannerProps) => {
  return (
    <Box className={'Upgrade_upgradeBanner'}>
      <NoticeBox
        alignItems="center"
        justifyContent="center"
        message={message}
        component={button || <></>}
        fullWidth
      />
    </Box>
  )
}

export default {
  Tiny,
  Small,
  Large,
  Banner,
}
